import axios from "axios";
import { environment } from "../../../environment";
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/cash-cycle/v1/client/${clientId}/trigger`
    : `https://middleware.uat.farther.com/cash-cycle/v1/client/${clientId}/trigger`;
export default async function postTrigger(clientId, body, config) {
    const triggerBody = {
        schedule: body.schedule,
        amount: body.amount,
        method: transformMethodBody(body.method),
    };
    await axios.post(url(clientId), triggerBody, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
}
const transformMethodBody = (method) => {
    if (method.type === "fixed_amount") {
        return method;
    }
    return {
        type: "waterfall",
        accounts: method.accounts.map((acct, idx) => ({
            accountId: acct.accountId,
            waterfallOrder: idx + 1, // waterfallOrder starts at 1 not 0
        })),
    };
};
//# sourceMappingURL=postTrigger.js.map